"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOP_TRANSFER = exports.STOP = exports.START = exports.RESUME_TRANSFER = exports.GET_ALL_TRANSFERS = exports.START_TRANSFER = exports.START_HTTPGATEWAY_UPLOAD = exports.START_HTTPGATEWAY_DOWNLOAD = exports.SHOW_TRANSFER_MANAGER = exports.SHOW_SELECT_FOLDER_DIALOG = exports.SHOW_SELECT_FILE_DIALOG = exports.SHOW_PREFERENCES = exports.SHOW_DIRECTORY = exports.SELECT_FILES_FOR_UPLOAD = exports.DROP_FILES_FOR_UPLOAD = exports.ATTACH_DRAG_AND_DROP = void 0;
exports.ATTACH_DRAG_AND_DROP = 'ATTACH_DRAG_AND_DROP';
exports.DROP_FILES_FOR_UPLOAD = 'DROP_FILES_FOR_UPLOAD';
exports.SELECT_FILES_FOR_UPLOAD = 'SELECT_FILES_FOR_UPLOAD';
exports.SHOW_DIRECTORY = 'SHOW_DIRECTORY';
exports.SHOW_PREFERENCES = 'SHOW_PREFERENCES';
exports.SHOW_SELECT_FILE_DIALOG = 'SHOW_SELECT_FILE_DIALOG';
exports.SHOW_SELECT_FOLDER_DIALOG = 'SHOW_SELECT_FOLDER_DIALOG';
exports.SHOW_TRANSFER_MANAGER = 'SHOW_TRANSFER_MANAGER';
exports.START_HTTPGATEWAY_DOWNLOAD = 'START_HTTPGATEWAY_DOWNLOAD';
exports.START_HTTPGATEWAY_UPLOAD = 'START_HTTPGATEWAY_UPLOAD';
exports.START_TRANSFER = 'START_TRANSFER';
exports.GET_ALL_TRANSFERS = 'GET_ALL_TRANSFERS';
exports.RESUME_TRANSFER = 'RESUME_TRANSFER';
exports.START = 'START';
exports.STOP = 'STOP';
exports.STOP_TRANSFER = 'STOP_TRANSFER';
